/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayByPlayModelDto } from '../../models/play-by-play-model-dto';

export interface GameTrackerControllerGetGamePbp$Params {
  uuid: string;
}

export function gameTrackerControllerGetGamePbp(http: HttpClient, rootUrl: string, params: GameTrackerControllerGetGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayByPlayModelDto>>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerControllerGetGamePbp.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PlayByPlayModelDto>>;
    })
  );
}

gameTrackerControllerGetGamePbp.PATH = '/game-tracker/games/{uuid}/pbp';
